import { createReducer, on } from '@ngrx/store';
import { IOrganization } from '../../../shared/models/user/organization';
import {
  loadOrgProfile,
  loadOrgMembers,
  loadOrgReview,
  loadOrgClubs,
  loadOrgChapters,
  loadOrgJobs,
  addOrgReview,
  clearOrg
} from './organization.actions';
import {
  addContactSuccess,
  removeContactSuccess
} from '../../../core/services/contacts/contacts.actions';

export interface IOrganizationState {
  profile: IOrganization;
  reviews: object[];
  membersCount: number;
  members: object[];
  clubs: object[];
  jobs: object[];
  chapters: object[];
}

const initialState: IOrganizationState = {
  profile: null,
  reviews: [],
  membersCount: null,
  members: [],
  clubs: [],
  jobs: [],
  chapters: []
};

export const organizationReducer = createReducer(
  initialState,
  on(loadOrgProfile.success, (state, { payload }) => ({
    ...state,
    profile: payload
  })),
  on(loadOrgMembers.init, (state) => {
    return {
      ...state,
      members: null,
      membersCount: null
    };
  }),
  on(loadOrgMembers.success, (state, { payload: { members, count } }) => {
    return {
      ...state,
      members,
      membersCount: count
    };
  }),
  on(loadOrgClubs.success, (state, { payload }) => ({
    ...state,
    clubs: payload
  })),
  on(loadOrgJobs.success, (state, { payload }) => ({
    ...state,
    jobs: payload
  })),
  on(loadOrgChapters.success, (state, { payload }) => ({
    ...state,
    chapters: payload
  })),
  on(loadOrgReview.success, (state, { payload }) => ({
    ...state,
    reviews: payload
  })),
  on(addOrgReview.success, (state, { payload }) => ({
    ...state,
    reviews: [payload, ...state.reviews]
  })),
  on(addContactSuccess, (state, action) =>
    getConnectState(state, action.id, true)
  ),
  on(removeContactSuccess, (state, action) =>
    getConnectState(state, action.id, false)
  ),
  on(clearOrg, () => ({ ...initialState }))
);

function getConnectState(
  state: IOrganizationState,
  id: number,
  type: boolean
): IOrganizationState {
  const { profile } = state;
  const isProfile = profile?.id === id;

  if (isProfile) {
    // #Return#
    return { ...state, profile: { ...profile, is_friend: type } };
  }

  return state;
}
